<template>
    <div>
        <img :style="height" src="../assets/logo.png" srcset="../assets/logo.png 1x,
                    ../assets/logo@2x.png 2x,
                    ../assets/logo@3x.png 3x"
        />
    </div>
</template>

<script>
    export default {
        name: "Brrzzz",
        props:['scale'],
        data() {
            return {
                height: 0
            }
        },
        computed: {},
        watch: {
            scale: function(a,b) {
                this.height = this.getHeight();
            }
        },
        methods: {
            getHeight() {
                let scale = this.scale;
                const width = window.innerWidth;

                let ret;

                if (width <= 375) {
                    ret = {width: `${150 * scale}px`};
                } else if (width <= 1000) {
                    ret = {width: `${200 * scale}px`};
                } else {
                    ret = {width: `${100 * scale}%`};
                }

                return ret;
            }
        },
        mounted() {
            this.height = this.getHeight();
            window.addEventListener('resize', () => {
                this.height = this.getHeight();
            });
        }
    }
</script>

<style lang="scss" scoped>

</style>